import Slider from './slider';

class VideoSlider extends Slider {
  constructor(el) {

    const sliderOptions = {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        640: {
            slidesPerView: 'auto',
            spaceBetween: 84  
        },
      },
    };

    super(el, sliderOptions);
  }

  bindEvents() {
    this.swiper.on('init', () => this.handleVideoPlayState());
    this.swiper.on('slideChangeTransitionStart', () => this.handleVideoPlayState());
  }

  handleVideoPlayState() {
    if (!this.swiper || !this.swiper.slides) return;
    this.swiper.slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (!video) return;
      slide.classList.contains('swiper-slide-active') ? video.play() : video.pause();
    });
  }
}

export default VideoSlider;
